<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-card>
      <card-toolbar title="Gelen Mesaj Raporları"></card-toolbar>
      <v-card-text>
        <v-layout :row="$vuetify.breakpoint.smAndDown">
          <!-- SOL -->
          <v-flex
            md3
            xs12
          >
            <v-form ref="form">
              <v-flex xs12>
                <!-- START DATE -->
                <date-month-picker
                  label="Başlangıç Tarihi"
                  :rules="[
                  $rules.required({
                    falseValues: [''],
                    message: 'Bir başlangıç tarihi seçmelisiniz',
                  }),
                ]"
                  @on:date-selected="(val) => { date.start = val; }"
                >
                </date-month-picker>
              </v-flex>
              <v-flex xs12>
                <!-- END DATE -->
                <date-month-picker
                  label="Bitiş Tarihi"
                  :rules="[
                            $rules.required({
                              falseValues: [''],
                              message: 'Bir bitiş tarihi seçmelisiniz',
                            }),
                          ]"
                  @on:date-selected="(val) => { date.end = val; }"
                >
                </date-month-picker>
              </v-flex>
              <v-flex
                xs12
                class="text-right"
              >
                <v-btn
                  color="primary"
                  @click.stop="load"
                >
                  Mesajlari Yükle
                </v-btn>
              </v-flex>
            </v-form>
          </v-flex>

          <v-divider
            v-if="$vuetify.breakpoint.mdAndUp"
            vertical
          ></v-divider>

          <!-- SAĞ -->
          <v-flex
            xs12
            md6
          >
            <v-chip
              class="ma-2"
              color="pink"
              label
              text-color="white"
            >
              <v-icon left>mdi-label</v-icon>
              850 Numaranıza Gelen Mesajlar
            </v-chip>
            <v-data-table
              :headers="headers1"
              :items="data.oztek"
            >
            </v-data-table>
          </v-flex>

          <v-divider
            v-if="$vuetify.breakpoint.mdAndUp"
            vertical
          ></v-divider>

          <v-flex
            xs12
            md6
          >
            <v-chip
              class="ma-2"
              color="pink lighten-1"
              label
              text-color="white"
            >
              <v-icon left>mdi-label</v-icon>
              Kısa Koda Gelen Mesajlar
            </v-chip>
            <v-data-table
              :headers="headers2"
              :items="data.keyword"
            >
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import DateMonthPicker from '../../Components/SMSConstants/DateMonthPicker.vue';
import CardToolbar from '../../Components/CardToolbar.vue';
import { downloadFile } from '@/misc';

export default {
  name: 'Incoming',
  components: { CardToolbar, DateMonthPicker },
  data: () => ({
    data: [],
    date: {
      start: new Date()
        .toJSON()
        .replace('T', ' ')
        .substr(0, 10),
      end: new Date()
        .toJSON()
        .replace('T', ' ')
        .substr(0, 10),
    },
    headers1: [
      { text: 'Tarih', value: 'tarih' },
      { text: 'Mesaj', value: 'mesaj' },
      { text: 'Gönderici', value: 'gonderici' },
      { text: 'Alıcı', value: 'alici' },
    ],
    headers2: [
      { text: 'Tarih', value: 'created_at' },
      { text: 'Mesaj', value: 'message' },
      { text: 'Gönderici', value: 'phone' },
      { text: 'Kısa Kod', value: 'keyword' },
    ],
  }),
  methods: {
    downloadFile,
    ...mapActions({ send: 'sendBackend' }),
    created() {
      this.load();
    },
    load() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.send({
        route: 'show/incoming/messages',
        data: { start_date: this.date.start, end_date: this.date.end },
      }).then((res) => {
        this.data = res.data.data;
      });
    },
    exportExcel() {
      const fileName = `${this.$store.state.user.name} ${this.$store.state.user.surname}-Gelen_Mesaj_Raporlar`;
      this.axios.get('export/incoming/messages', {
        responseType: 'arraybuffer',
      }).then((res) => { this.downloadFile(res, fileName); });
    },
  },
};
</script>
